export const currencies = [
  {
    name: 'DOLAR',
    icon: 'dollar',
    currency: 'USD',
    sellingRate: 0,
    buyingRate: 0,
    changeIndicatorCN: -0.11,
    changeIndicatorAN: -0.0354,
    timestamp: '2024-05-27T11:56:14.134Z',
  },
  {
    name: 'EURO',
    icon: 'euro',
    currency: 'EUR',
    sellingRate: 0,
    buyingRate: 0,
    changeIndicatorCN: 0.11,
    changeIndicatorAN: 0.0384,
    timestamp: '2024-05-27T11:56:14.002Z',
  },
  {
    name: 'ETH',
    icon: 'ethereum',
    currency: 'ethereum',
    sellingRate: 0,
    buyingRate: 0,
    changeIndicatorCN: 2.49,
    changeIndicatorAN: 94.75,
    timestamp: '2024-05-27T11:55:17.849Z',
  },
  {
    name: 'ALTIN',
    icon: 'gold',
    currency: 'gram-altin',
    sellingRate: 0,
    buyingRate: 0,
    changeIndicatorCN: 0.38,
    changeIndicatorAN: 9.19,
    timestamp: '2024-05-27T11:56:15.432Z',
  },
  {
    name: 'BITCOIN',
    icon: 'bitcoin',
    currency: 'bitcoin',
    sellingRate: 0,
    buyingRate: 0,
    changeIndicatorCN: -0.98,
    changeIndicatorAN: -677,
    timestamp: '2024-05-27T11:55:17.325Z',
  },
  {
    name: 'BIST100',
    icon: 'bist100',
    currency: 'XU100',
    sellingRate: 0,
    buyingRate: 0,
    changeIndicatorCN: 0.49,
    changeIndicatorAN: 52.31,
    timestamp: '2024-05-27T11:55:36.955Z',
  },
];
